{
  "schemaVersion": "1.0",
  "project": "小狗旅行",
  "bibleVersion": "v0.7",
  "manifestOpenedAt": "2026-09-15",
  "metadata": {
    "warning": "bytesWebp 字段当前填的是 ref/ PNG 实测 size（临时占位），不是真正的 WebP 体积。Phase 4 工程侧转换 PNG→WebP 后必须回填此字段。Schema 校验规则 6 要求正整数，当前用 ref/ size 满足，但实际意义待 Phase 4 落地。",
    "inBundleSemantics": "全部 13 条 inBundle=false。理由：ref/ 是人工定稿锚图，不是生产资源。工程侧按 Phase 4 §8 资产索引层实现规则，转换 WebP 后写入 assets/ 才置 true。Schema 校验规则 3 要求路径含 /raw/ 或 /ref/ 时 inBundle 必须为 false——当前满足。",
    "image1Nulls": "room_day 与 dog_idle 两条 image1=null，因为是 v0.5 首批出图时无锚图可用（无前作可参考）。v0.6 之后的所有 gift_* 都有 image1 锚图来源。; postcard_riverside 有 image1=anchor_dog_idle。",
    "promptFullPlaceholder": "prompt.full 字段当前是指针式占位（'见 prompt-pack-XX §X'）。这是 v0.5 之前我们讨论的方案 B：等下次跑图时按实际执行串逐字回填。Schema 校验规则 6 要求 approved 资产 prompt.full 非空——指针占位满足，但不可作为可执行指令。",
    "versionedStyles": "STYLE/ICON/NEG 字段按实际生成时的 prompt-pack 版本填写：v0.7 batch 用 hand-painted + OG ICON；v0.8 re-runs 用 gouache-painted + 严格 alpha ICON + 防御性 NEG。v0.8 改写后的版本与历史实际执行一致。"
  },
  "generator": {
    "tool": "ImageGen",
    "model": "待确认（team-lead 未说明 ImageGen 底层模型）",
    "modelVersion": "待确认",
    "seedBase": null,
    "seedStrategy": "image1-anchored, input_fidelity 0.35 (normal/uncommon) / 0.40 (rare/legendary)",
    "lockedAt": "2026-09-15"
  },
  "assets": [
    {
      "id": "room_day",
      "file": "ref/anchor_room_day.png",
      "rawFile": "raw/room_day.outpainted.2026-09-18.png",
      "anchorFile": "ref/anchor_room_day.png",
      "category": "scene",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 864,
        "h": 1536
      },
      "bytesWebp": 225684,
      "bytesRawPng": 3138285,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a cozy small wooden room interior, three-quarter front view with a slight 8 to 12 degree downward angle, warm honey-toned wooden floorboards, a small round window on the upper left wall with soft afternoon sunlight streaming through, a low wooden table, a round woven rug in deep forest green #56754B placed in the center lower area, a woven dog bed, a small travel backpack and a hand-drawn map hanging on the wall, a small potted plant on the windowsill, a single ceramic cup, no more than seven pieces of furniture, generous empty floor space in the lower third of the frame, vertical 9 to 16 composition",
        "suffix": "full-bleed vertical composition, no transparent background, foreground furniture at bottom third, soft window light from upper-left, generous empty floor space at lower third for UI overlay",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-01 §1 拼接后的成品串（v0.5 时代已固化；prompt-pack-01 §1/§2 是当时的 6 段拼装结果，与本次执行逐字一致）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "首批锚图。验收要点 4（深苔绿地毯 #56754B）已核对通过——此项不通过直接打回。下游请走工程后处理裁掉 AI 生成 WORKBUDDY 水印。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [
        {
          "at": "2026-09-18",
          "what": "根因B治本：原图 1024×1476（≈2:3）在竖屏手机被 object-fit:cover 横向裁掉最多约 31%（圆窗/墙地图被切）。以清洗后的原图为锚（input_fidelity 0.40，gouache 画风）外扩重生成 864×1536（严格 9:16），画面下部新增木长凳+坐垫+盆栽（room 候选 2，老板拍板）。工程后处理：ffmpeg delogo 抠除右下角 AI生成 WORKBUDDY 水印（x=622,y=1472,w=218,h=60），保留完整 9:16 画幅（不再做 60px 底部裁切，避免破坏 9:16）。源：art/raw/room_day.outpainted.2026-09-18.png；产物 public/assets/scenes/room/room_day@2x.webp。"
        }
      ],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-18",
      "notes": "v0.5 首批 4 张候选选 1；no image1（首批无锚图）；prompt-pack-01 §1 全拼接串。v2.2（2026-09-18）起为 9:16 外扩版（见 edits[0]），根因B治本。"
    },
    {
      "id": "scene_yard_day",
      "file": "raw/scene_yard_day.raw.2026-09-18.png",
      "rawFile": "raw/scene_yard_day.raw.2026-09-18.png",
      "anchorFile": "raw/courtyard_v2.2026-09-17.png",
      "category": "yard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1024,
        "h": 1536
      },
      "bytesWebp": 234656,
      "bytesRawPng": 3461403,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, gouache-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "the same cozy cottage front yard as in the reference image, upper half unchanged: wooden picket fence with an arched wooden gate, potted watering can, birdhouse mailbox, flower beds with orange and white daisies on both sides, a stone path leading from the gate to the center. lower half filled: a small wooden doghouse on the lower left, a round stone platform in the center (the dog's spot), a stone lantern, three terracotta flower pots on the right, stepping stones continuing downward",
        "suffix": "full-bleed vertical composition, no transparent background, generous grass space at the lower third for UI overlay, warm afternoon sunlight consistent with the room interior",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, watermark, text, letters, signature, logo, multiple subjects, cropped, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, metallic, chrome, glass, watercolor halo, paper background, dirt mound, rock pile",
        "full": "图生图执行串（2026-09-18）：anchor=清洗后的 courtyard_v2（裁 60px 水印），STYLE gouache，subject 如上，input_fidelity 0.40，size 1024x1536，quality high，background opaque"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "raw/courtyard_v2.2026-09-17.png",
      "inputFidelity": 0.4,
      "validatedAgainst": "老板 2026-09-18 在 2 张候选中拍板候选 2（courtyard_c2）：木狗屋居左+石灯笼+中央石台+右侧 3 盆栽，下半部不再空。已知限制：1024×1536（2:3），在窄长屏（≈0.46 视口）被 cover 横裁最多约 31%，狗屋/花盆可能被切边；如需完整呈现须再外扩 9:16（待老板决定）。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-18"
      },
      "edits": [
        {
          "at": "2026-09-18",
          "what": "工程后处理：ffmpeg delogo 抠除右下角 AI生成 WORKBUDDY 水印（x=726,y=1468,w=266,h=64），保留完整画幅。源：art/raw/scene_yard_day.raw.2026-09-18.png；产物 public/assets/scenes/yard/scene_yard_day@2x.webp。"
        }
      ],
      "createdAt": "2026-09-18",
      "updatedAt": "2026-09-18",
      "notes": "庭院底图 v1（2026-09-18）：以 courtyard_v2.2026-09-17 为锚外扩补全下半部；老板 2 候选拍板候选 2。category=yard（schema 枚举已扩）。"
    },
    {
      "id": "dog_idle",
      "file": "ref/anchor_dog_idle.png",
      "rawFile": "raw/dog_idle.raw.png",
      "anchorFile": "ref/anchor_dog_idle.png",
      "category": "character",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 63706,
      "bytesRawPng": 765039,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a chubby Pembroke Welsh corgi puppy, chibi proportions with total height 2.1 times head height, very large upright triangular ears with ear height 0.55 of head height, fox-like face, white blaze running up the muzzle between the eyes, heart-shaped white bib covering chin and chest, honey-brown #C98A46 coat, darker #A5662F fur on back and ear backs, white muzzle and white paws, extremely short stubby legs with leg height one quarter of head height, long low body with body length 1.6 times body height, broad round rear, natural bobtail, a small tuft of fur standing up between the ears, wearing a small mustard-yellow #D9A62E neckerchief, two solid black oval eyes, small black triangular nose, gentle closed-mouth smile",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in the reference image, identical proportions, identical large upright triangular ears, identical white bib shape and placement, identical honey-brown coat color, identical extremely short legs and long low body, identical white blaze on the muzzle, identical tuft of fur standing up between the ears, identical mustard-yellow neckerchief",
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-01 §2 拼接后的成品串（v0.5 时代已固化；prompt-pack-01 §1/§2 是当时的 6 段拼装结果，与本次执行逐字一致）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "首批锚图。老板在 18-02-17 与 18-02-36 间选了 18-02-36：眼神更柔、嘴角弧度更自然。小狗额外必查两项（腿高 ≤0.25 头高、双耳完全竖立等高）已过。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [
        {
          "at": "2026-09-15",
          "what": "坐姿重制：老板确认站姿违反美术圣经（禁止站立/作揖），批准重出 1 张坐姿。ImageGen 图生图（参考原站姿锚图，保持画风/黄领巾一致性）→ 本地 flood-fill 抠白底（scripts/local-matte-dog.py，thresh=40，背景单一连通块 68.8%，狗内部无破洞）。源图 raw/The_exact_same_corgi_dog_chara_2026-09-15T08-24-16.png；旧站姿锚图备份 raw/anchor_dog_idle.standing.bak.png。"
        }
      ],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.5 首批 4 张候选选 1；no image1（首批无锚图）；prompt-pack-01 §2 全拼接串。v0.9 起为坐姿版（见 edits[0]）。"
    },
    {
      "id": "gift_shell",
      "file": "ref/anchor_gift_shell.png",
      "rawFile": "raw/gift_shell.raw.png",
      "anchorFile": "ref/anchor_gift_shell.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 17362,
      "bytesRawPng": 1148972,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small seashell, fan-shaped scallop shell, warm cream and pale pink tones, interior polished surface with subtle pearly sheen #F2DCC8, soft natural ridges radiating from the hinge, delicate paper-grain texture, gentle warm afternoon light from upper-left, calm seaside memory mood. subtle warm cream glow #F2C78A around the silhouette, soft and minimal",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-02 §1 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_dog_idle.png",
      "inputFidelity": 0.35,
      "validatedAgainst": "v0.7 锚图候选；形态最标准扇贝；推荐 1。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.7 锚图候选 4 张选 1；image1=anchor_dog_idle（icon-anchor pool 雏形）；prompt-pack-02 §1。",
      "tier": "uncommon"
    },
    {
      "id": "gift_pinecone",
      "file": "ref/anchor_gift_pinecone.png",
      "rawFile": "raw/gift_pinecone.raw.png",
      "anchorFile": "ref/anchor_gift_pinecone.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 18400,
      "bytesRawPng": 1211068,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small unripe closed pinecone, similar in shape and proportion to a small plump seed pod, tightly overlapping scaly bracts pressed flat against the body like roof tiles, no opened or splayed scales, no exposed inner texture, no needles, warm pine brown #B8895C with slightly darker scale edges, gentle warm afternoon light from upper-left, cozy autumn forest floor mood. subtle warm cream glow #F2C78A around the silhouette, soft and minimal",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-02 §0 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_dog_idle.png",
      "inputFidelity": 0.35,
      "validatedAgainst": "v0.7 锚图；首跑鳞片外翻失败已修复（v0.7 prompt-pack §0 seed pod 锚点 + closed-scales 负面禁止）；18-31-32 是修复后 4 张候选的主推。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.7 锚图修复后候选；image1=anchor_dog_idle；prompt-pack-02 §0。",
      "tier": "uncommon"
    },
    {
      "id": "gift_wind_chime",
      "file": "ref/anchor_gift_wind_chime.png",
      "rawFile": "raw/gift_wind_chime.raw.png",
      "anchorFile": "ref/anchor_gift_wind_chime.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 17282,
      "bytesRawPng": 1189623,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small ceramic wind chime, artisan studio pottery texture in warm clay tones #C08A5A, three to four small bell-shaped ceramic pieces hanging from a short wooden twig, natural hemp string in muted natural color, gentle warm afternoon light from upper-left, quiet village workshop mood. warm gold outline #E0A94E thickness 6 pixels at 512 canvas, plus one or two small gold four-pointed stars about 24 pixels diameter baked into the image",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-02 §4 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_pinecone.png",
      "inputFidelity": 0.4,
      "validatedAgainst": "v0.7 主推（18-34-48）：3 铃+3 星最匀。陶制（v0.5 §6 无金属约束），design-strategist 文案「声音闷闷的」。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.7 候选 4 张选 1；image1=anchor_gift_pinecone；prompt-pack-02 §4。",
      "tier": "rare"
    },
    {
      "id": "gift_honey_jar",
      "file": "ref/anchor_gift_honey_jar.png",
      "rawFile": "raw/gift_honey_jar.raw.png",
      "anchorFile": "ref/anchor_gift_honey_jar.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 16646,
      "bytesRawPng": 1205751,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small artisan studio pottery honey jar, round-bellied clay jar in warm terracotta #C08A5A as the dominant color, small wooden cork stopper tied with a short piece of natural twine, a thin amber #D9A05B trickle of honey barely visible at the jar mouth, no glass no metal no label, gentle warm afternoon light from upper-left, cozy kitchen garden mood. warm gold outline #E0A94E thickness 6 pixels at 512 canvas, plus one or two small gold four-pointed stars about 24 pixels diameter baked into the image",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-02 §5 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_pinecone.png",
      "inputFidelity": 0.4,
      "validatedAgainst": "v0.7 主推（18-37-01）：蝴蝶结最精致。粗陶 #C08A5A 主色 + 木塞；与糖画撞色预防已写入（陶土 vs 琥珀）。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.7 候选选 1；image1=anchor_gift_pinecone；prompt-pack-02 §5。老板拍板 MVP 进。",
      "tier": "rare"
    },
    {
      "id": "gift_postcard",
      "file": "ref/anchor_gift_postcard.png",
      "rawFile": "raw/gift_postcard.raw.png",
      "anchorFile": "ref/anchor_gift_postcard.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 19120,
      "bytesRawPng": 1555529,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small artisan studio postcard lying flat, warm cream paper #F2E4CE, gouache-painted abstract pattern only: a simple distant mountain silhouette in soft blue-green #93B87C plus a single warm sunset #F2A65A wash on one corner, no text no stamp no writing no photo. gentle warm afternoon light from upper-left, nostalgic travel memory mood. subtle warm cream glow #F2C78A around the silhouette, soft and minimal",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-02 §6 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_pinecone.png",
      "inputFidelity": 0.35,
      "validatedAgainst": "v0.7 主推（18-38-27）：唯一带飞鸟那版，远方感强。明信片禁文字禁邮戳，强制抽象图案。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.7 候选选 1；image1=anchor_gift_pinecone；prompt-pack-02 §6。",
      "tier": "uncommon"
    },
    {
      "id": "gift_star_bottle",
      "file": "ref/anchor_gift_star_bottle.png",
      "rawFile": "raw/gift_star_bottle.raw.png",
      "anchorFile": "ref/anchor_gift_star_bottle.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 11570,
      "bytesRawPng": 1151884,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small artisan studio ceramic star bottle, squat round-bellied pottery bottle in warm cream clay #E8D4B4 with a small cork stopper, three to five tiny warm gold #F2C78A star-shaped light particles inside the bottle glowing softly, no glass no transparency no chemistry-lab feel, gentle warm afternoon light from upper-left, magical bedtime mood. warm gold outline #E0A94E thickness 8 pixels at 512 canvas, plus three to five tiny warm gold light particles about 8 to 14 pixels diameter baked into the image, with a gentle warm halo overall",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-02 §7 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_pinecone.png",
      "inputFidelity": 0.4,
      "validatedAgainst": "v0.7 主推（18-39-46）：4+4 光点群最丰富。陶罐非玻璃，反化学实验品。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.7 候选选 1；image1=anchor_gift_pinecone；prompt-pack-02 §7。",
      "tier": "legendary"
    },
    {
      "id": "gift_pebble",
      "file": "ref/anchor_gift_pebble.png",
      "rawFile": "raw/gift_pebble.raw.png",
      "anchorFile": "ref/anchor_gift_pebble.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 14898,
      "bytesRawPng": 1149085,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, gouache-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small smooth river pebble, warm grey-brown #A89484 with a subtle warm undertone, gentle paper-grain texture, gentle warm afternoon light from upper-left, calm riverbank memory mood",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background with strict alpha cutoff no watercolor halo bleed, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, centered horizontally and vertically, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner, hand, hands, hand shape, human hand, palm, fingers, not a pinecone, not a seed pod, not a closed pinecone shape",
        "full": "见 prompt-pack-02 §9 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_shell.png",
      "inputFidelity": 0.35,
      "validatedAgainst": "v0.8 主推（23-39-15）：治本 C+A 修复。v0.7.18-41-28 反向带跑生成松果，v0.8 改用 shell 锚图 + NEG 加 not a pinecone。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.8 重跑候选选 1；image1=anchor_gift_shell（v0.8 anchor rotation 治本）；prompt-pack-02 §9。",
      "tier": "normal"
    },
    {
      "id": "gift_maple_bookmark",
      "file": "ref/anchor_gift_maple_bookmark.png",
      "rawFile": "raw/gift_maple_bookmark.raw.png",
      "anchorFile": "ref/anchor_gift_maple_bookmark.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 15946,
      "bytesRawPng": 1219775,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small pressed maple leaf, autumn orange-red #C96A3E with a touch of warm yellow #E0A94E near the stem, delicate paper-grain veins visible, leaf is dry and flat not curled, gentle warm afternoon light from upper-left, hushed autumn reading mood",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-02 §9 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_pinecone.png",
      "inputFidelity": 0.35,
      "validatedAgainst": "v0.7 主推（18-42-29）：叶柄最自然。单片干枫叶，无字无绳。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.7 候选选 1；image1=anchor_gift_pinecone；prompt-pack-02 §9 (枫叶书签)。",
      "tier": "normal"
    },
    {
      "id": "gift_mushroom",
      "file": "ref/anchor_gift_mushroom.png",
      "rawFile": "raw/gift_mushroom.raw.png",
      "anchorFile": "ref/anchor_gift_mushroom.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 10380,
      "bytesRawPng": 1124664,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small soft mushroom, warm tan-brown cap #B8895C, cream-white stem #F2E4CE, plump and friendly proportions, no spots no stripes no red coloring, gentle warm afternoon light from upper-left, cozy forest floor mood",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner",
        "full": "见 prompt-pack-02 §10 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_pinecone.png",
      "inputFidelity": 0.35,
      "validatedAgainst": "v0.7 主推（18-43-31）：菌盖最饱满。暖米褐菌盖 #B8895C + 奶白菌柄，无红白点毒蘑菇配色。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.7 候选选 1；image1=anchor_gift_pinecone；prompt-pack-02 §10。",
      "tier": "normal"
    },
    {
      "id": "gift_twig",
      "file": "ref/anchor_gift_twig.png",
      "rawFile": "raw/gift_twig.raw.png",
      "anchorFile": "ref/anchor_gift_twig.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 6752,
      "bytesRawPng": 952039,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, gouache-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small smooth twig about 3 to 4 cm visual length, light birch-bark tan #C4A882 with delicate paper-grain bark texture, two or three small branching forks at 30 to 45 degree angles, one half-curled dried leaf #C58A4A still attached at the tip, no broken pale fresh-cut stub, no charred black ends, no insect damage, no mold, a charming found-on-the-ground twig, gentle warm afternoon light from upper-left, peaceful forest walk mood",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background with strict alpha cutoff no watercolor halo bleed, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, centered horizontally and vertically, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner, hand, hands, hand shape, human hand, palm, fingers, not a pinecone, not a seed pod, not a closed pinecone shape",
        "full": "见 prompt-pack-02 §12 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_shell.png",
      "inputFidelity": 0.35,
      "validatedAgainst": "v0.8 主推（23-39-58）：治本 C+A 修复。v0.7 18-46-25 反向带跑生成松果且 18-46-43 主推仍有偏移，v0.8 改用 shell 锚图 + NEG 加 not a pinecone。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.8 重跑候选选 1；image1=anchor_gift_shell（v0.8 anchor rotation 治本）；prompt-pack-02 §12。",
      "tier": "normal"
    },
    {
      "id": "gift_marshmallow",
      "file": "ref/anchor_gift_marshmallow.png",
      "rawFile": "raw/gift_marshmallow.raw.png",
      "anchorFile": "ref/anchor_gift_marshmallow.png",
      "category": "gift",
      "status": "approved",
      "alpha": true,
      "dimensions": {
        "w": 1024,
        "h": 1024
      },
      "bytesWebp": 11362,
      "bytesRawPng": 1059523,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, gouache-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "a single small artisan studio marshmallow treat, soft puffy white-cream cloud shape #FBF7EF with a faint warm pink blush #F2C8A8, wrapped loosely in a small piece of crinkled warm beige paper #E8D4B4, no stick no machine no metal, gentle warm afternoon light from upper-left, festive market town mood",
        "suffix": "centered composition, single small object, three-quarter overhead view about 30 degrees downward angle, soft diffused lighting from upper-left at 45 degrees consistent with the room light, no harsh shadows, isolated on transparent background with strict alpha cutoff no watercolor halo bleed, clean alpha edges, subject occupying 78 percent of frame with 11 percent margin all sides, centered horizontally and vertically, consistent line weight, print-like color separation",
        "char": null,
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, dark background, gradient background, watermark, text, letters, signature, logo, multiple subjects, cropped, extra limbs, blurry, low resolution, jpeg artifacts, oversaturated, neon colors, cold color grading, drop shadow on alpha, metallic, chrome, plastic, glass, watercolor halo, paper background, off-center subject, subject in corner, hand, hands, hand shape, human hand, palm, fingers, not a pinecone, not a seed pod, not a closed pinecone shape",
        "full": "见 prompt-pack-02 §11 拼接后的成品串（v0.8 模板，含 gouache-painted STYLE + 严格 alpha ICON + 防御性 NEG；asset-specific 在 prompt-pack-02 该段 SUBJECT 处；本次 实际执行前可能与现模板有微差，待下次跑图按实际执行串逐字回填）"
      },
      "seed": null,
      "seedsTried": null,
      "image1": "ref/anchor_gift_shell.png",
      "inputFidelity": 0.35,
      "validatedAgainst": "v0.8 主推（23-37-27）：纸边皱褶最自然，云形棉花糖裹纸形态。v0.7 18-45-50 误生成手形，v0.8 治本（[STYLE] hand-painted → gouache-painted；subject handmade → artisan studio；NEG 加 hand/hands/palm/fingers 兜底）。4/4 全部非手形，治本验证成功。",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-15"
      },
      "edits": [],
      "createdAt": "2026-09-15",
      "updatedAt": "2026-09-15",
      "notes": "v0.8 重跑候选选 1；image1=anchor_gift_shell；prompt-pack-02 §11。",
      "tier": "normal"
    },
    {
      "id": "postcard_riverside_01",
      "file": "raw/postcard_riverside_01.2026-09-17.png",
      "rawFile": "raw/postcard_riverside_01.2026-09-17.png",
      "anchorFile": "raw/postcard_riverside.riverside-v1.2026-09-16.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 59888,
      "bytesRawPng": 1061994,
      "inBundle": false,
      "prompt": {
        "style": "Japanese picture-book watercolor illustration, soft gouache texture, visible paper grain, gentle warm low-saturation palette, delicate thin ink outlines, hand-painted children's storybook art, flat 2D with subtle shading, cozy healing mood (iyashikei), warm afternoon light, no photorealism, no 3D render",
        "subject": "composed postcard: left area a photo of a chubby corgi puppy playing in shallow water at a riverside, right/bottom area handwritten Chinese calligraphy text on lined paper. The corgi has honey-brown fur, upright triangular ears, white blaze on muzzle, mustard-yellow neckerchief.",
        "suffix": "Horizontal 4 to 3 composition, full-bleed postcard with photo area and handwritten text area, no border text",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render, octane render, plastic texture, heavy outlines, thick black lineart, watermark, text outside designated area",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": "raw/postcard_riverside_composed_v1.2026-09-17.png",
      "inputFidelity": "0.40",
      "validatedAgainst": "老板 2026-09-17 确认采纳，文字「水浅的地方，脚趾踩得进沙里。」已烘入图中",
      "checks": {
        "passed": true,
        "anchorCompared": true,
        "failedItems": [],
        "checkedBy": "art-director",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-16",
      "updatedAt": "2026-09-17",
      "notes": "riverside 明信片①：合成图含小狗玩水照片 + 文字「水浅的地方，脚趾踩得进沙里。」"
    },
    {
      "id": "postcard_riverside_02",
      "file": "raw/postcard_riverside_02.2026-09-17.png",
      "rawFile": "raw/postcard_riverside_02.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 78540,
      "bytesRawPng": 1153034,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for riverside destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": "raw/postcard_riverside_composed_v1.2026-09-17.png",
      "inputFidelity": "0.40",
      "validatedAgainst": "riverside 明信片②；文案待回填",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "riverside 明信片②：合成图含小狗玩水照片 + 手写文字"
    },
    {
      "id": "postcard_riverside_03",
      "file": "raw/postcard_riverside_03.2026-09-17.png",
      "rawFile": "raw/postcard_riverside_03.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 68946,
      "bytesRawPng": 1111133,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for riverside destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": "raw/postcard_riverside_composed_v1.2026-09-17.png",
      "inputFidelity": "0.40",
      "validatedAgainst": "riverside 明信片③；文案待回填",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "riverside 明信片③：合成图含小狗玩水照片 + 手写文字"
    },
    {
      "id": "postcard_forest_01",
      "file": "raw/postcard_forest_01.2026-09-17.png",
      "rawFile": "raw/postcard_forest_01.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 91600,
      "bytesRawPng": 1194081,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for forest destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "forest 明信片①",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "forest 明信片①：合成图含小狗森林照片 + 手写文字"
    },
    {
      "id": "postcard_forest_02",
      "file": "raw/postcard_forest_02.2026-09-17.png",
      "rawFile": "raw/postcard_forest_02.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 80994,
      "bytesRawPng": 1161472,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for forest destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "forest 明信片②",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "forest 明信片②：合成图含小狗森林照片 + 手写文字"
    },
    {
      "id": "postcard_forest_03",
      "file": "raw/postcard_forest_03.new.2026-09-17.png",
      "rawFile": "raw/postcard_forest_03.new.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 77150,
      "bytesRawPng": 1138364,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for forest destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "forest 明信片③（修复版）；文字中括号已修复",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [
        {
          "at": "2026-09-17",
          "what": "postcard_forest_03.new 替换 postcard_forest_03（修复文字多余中括号）"
        }
      ],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "forest 明信片③（new 修复版）：合成图含小狗森林照片 + 手写文字，文字中括号已修复"
    },
    {
      "id": "postcard_hill_01",
      "file": "raw/postcard_hill_01.2026-09-17.png",
      "rawFile": "raw/postcard_hill_01.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 55742,
      "bytesRawPng": 1058023,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for hill destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "hill 明信片①",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "hill 明信片①：合成图含小狗山丘照片 + 手写文字"
    },
    {
      "id": "postcard_hill_02",
      "file": "raw/postcard_hill_02.new.2026-09-17.png",
      "rawFile": "raw/postcard_hill_02.new.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 67092,
      "bytesRawPng": 1105340,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for hill destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "hill 明信片②（修复版）；文字多余中括号已修复",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [
        {
          "at": "2026-09-17",
          "what": "postcard_hill_02.new 替换 postcard_hill_02（修复文字多余中括号）"
        }
      ],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "hill 明信片②（new 修复版）：合成图含小狗山丘照片 + 手写文字，文字中括号已修复"
    },
    {
      "id": "postcard_hill_03",
      "file": "raw/postcard_hill_03.new.2026-09-17.png",
      "rawFile": "raw/postcard_hill_03.new.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 55282,
      "bytesRawPng": 1060794,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for hill destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "hill 明信片③（修复版）；缺失文字已补全",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [
        {
          "at": "2026-09-17",
          "what": "postcard_hill_03.new 替换 postcard_hill_03（修复文字缺失）"
        }
      ],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "hill 明信片③（new 修复版）：合成图含小狗山丘照片 + 手写文字，缺失文字已补全"
    },
    {
      "id": "postcard_town_01",
      "file": "raw/postcard_town_01.2026-09-17.png",
      "rawFile": "raw/postcard_town_01.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 77702,
      "bytesRawPng": 1137406,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for town destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "town 明信片①",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "town 明信片①：合成图含小狗小镇照片 + 手写文字"
    },
    {
      "id": "postcard_town_02",
      "file": "raw/postcard_town_02.2026-09-17.png",
      "rawFile": "raw/postcard_town_02.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 77192,
      "bytesRawPng": 1147938,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for town destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "town 明信片②",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "town 明信片②：合成图含小狗小镇照片 + 手写文字"
    },
    {
      "id": "postcard_town_03",
      "file": "raw/postcard_town_03.2026-09-17.png",
      "rawFile": "raw/postcard_town_03.2026-09-17.png",
      "category": "postcard",
      "status": "approved",
      "alpha": false,
      "dimensions": {
        "w": 1536,
        "h": 1024
      },
      "bytesWebp": 69298,
      "bytesRawPng": 1113832,
      "inBundle": false,
      "prompt": {
        "style": null,
        "subject": "composed postcard for town destination with dog photo and handwritten Chinese text",
        "suffix": "Horizontal 4 to 3, full-bleed postcard",
        "char": "the same chubby Pembroke Welsh corgi puppy character as in anchor_dog_idle.png",
        "negative": "photorealistic, 3D render",
        "full": null
      },
      "seed": null,
      "seedsTried": null,
      "image1": null,
      "inputFidelity": null,
      "validatedAgainst": "town 明信片③",
      "checks": {
        "passed": true,
        "anchorCompared": false,
        "failedItems": [],
        "checkedBy": "team-lead",
        "checkedAt": "2026-09-17"
      },
      "edits": [],
      "createdAt": "2026-09-17",
      "updatedAt": "2026-09-17",
      "notes": "town 明信片③：合成图含小狗小镇照片 + 手写文字"
    }
  ]
}